module.exports = {

    methods: {

        openModal(element) {
            $('.' + element).modal({
                backdrop: 'static',
                // keyboard: false,
            }).modal('show')
        },

        closeModal(element) {
            $('.' + element).modal('hide')
        },

        isModalOpen(element) {
            return !!(($('.' + element).data('bs.modal') || {})._isShown)
        },
    }
}